<template>
  <section class="logout">
    <h5 class="logout__message">You are being logged out!</h5>
    <div class="logout__spinner-wrapper">
      <ClipLoader
        class="logout__spinner"
        :size="60"
        color="#ef7d22"
        sizeUnit="px"
      ></ClipLoader>
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
import { ClipLoader } from '@saeris/vue-spinners'

export default {
  name: 'Logout',
  components: {
    ClipLoader,
  },
  data() {
    return {
      redirectUrl: null,
    }
  },
  computed: {
    ...mapGetters({
      isAuthenticated: 'auth/isAuthenticated',
    }),
  },
  methods: {
    logout() {
      if (this.isAuthenticated) {
        this.$store.dispatch('auth/logout')
      }
      setTimeout(() => {
        if (this.redirectUrl && this.redirectUrl !== '') {
          window.location.assign(this.redirectUrl)
        } else {
          this.$router.push({ name: 'home' })
        }
      }, 1000)
    },
  },
  created() {
    const currentUrl = window.location.href
    const strippedUrl = decodeURIComponent(currentUrl).split('redirect_url=')[1]
    if (strippedUrl && strippedUrl !== '') this.redirectUrl = strippedUrl
    setTimeout(() => {
      this.logout()
    }, 1000)
  },
}
</script>

<style lang="scss" scoped>
.logout {
  background-color: var(--light-gray);
  padding-top: 300px;
  min-height: 70vh;
  &__message {
    margin: 0 auto;
    text-align: center;
    color: var(--white);
  }
  &__spinner-wrapper {
    width: 100%;
    color: var(--orange);
    margin: 20px auto 0 auto;
    text-align: center;
  }
}
</style>
